/** @jsxImportSource @emotion/react */

import { icons } from "assets/mobile";
import { LogoMobileHeader } from "assets/mobile/images";
import { PATH } from "contants/path";
import { useState } from "react";
import { Link } from "react-router-dom";

import SideBarMenu from "../SideBarMenu";
import { HeaderStyle } from "./index.style";
const { MenuButton, AppDownload } = icons;
export const HeaderMobile = () => {
  const [isSidebar, setIsSidebar] = useState<boolean>(false);
  return (
    <>
      <div css={HeaderStyle.index}>
        <div css={HeaderStyle.content}>
          <div onClick={() => setIsSidebar(true)} className="menu-click">
            <MenuButton />
          </div>
          <div className="logo">
            <Link to={PATH.Home}>
              <img src={LogoMobileHeader} alt="" />
            </Link>
          </div>
          <div className="download">
            <AppDownload />
          </div>
        </div>
      </div>
      <SideBarMenu
        isSidebar={isSidebar}
        onChangeSidebar={(val) => setIsSidebar(val)}
      />
    </>
  );
};
